<template>
  <div></div>
</template>

<script>
import accountService from "@/_services/api/account-service";
import { Constants } from "@/constants";
import settingsService from "@/_services/settings-service";

export default {
  name: "parameter-ctrl",

  methods: {
    create(data) {
      const params = {
        id: Constants.guid,
        applicationId: settingsService.get("applicationId"),
        expires: new Date().toISOString(),
        jsonData: JSON.stringify(data),
      };
      accountService.post("parameter", params, this.onSaveSuccess, this.onError);
    },

    onError(error) {
      console.log(error);
      this.$emit("error", "Authorization Service may be down, please try later.");
    },

    onSaveSuccess(result) {
      this.$emit("id", result.data.id);
    },

    get(id) {
      accountService.get(
        "parameter/" + id,
        this.onSuccess,
        this.onError
      );
    },

    onSuccess(result) {
      console.log("Result:", result);
      this.$emit("data", result.data);
    },

  }
}
</script>

<style>

</style>